import ContactForm from "@components/ContactForm/ContactForm";
import InstallAddonCta from "@components/Utils/InstallAddonCta";

const HelpTab = () => {
  return (
    <div className="pt-5 pb-10 w-full h-full lg:scrollbar-thin lg:scrollbar-thumb-gray-500 lg:overflow-y-scroll lg:scrollbar-thumb-rounded-full lg:scrollbar-track-rounded-full">
      <h1 className="pl-8 pb-2 text-3xl font-bold border-b-2">
        How to generate accurate formulas?
      </h1>

      <div className="max-w-[95%] mx-auto my-8 p-4 border-2 bg-white rounded-xl">
        <p className="mb-4">
          To ensure that the formulas generated are accurate, users are advised
          to use the exact column, row or cell names. Even though the AI can
          figured out what users prompt tries to say, it is advised be as
          specific with the query as possible.{" "}
          <span className="text-green-700 font-semibold">
            For example : Sum column A when cell B10 equals the word hello
          </span>
        </p>

        <p className="mb-4">
          In case of If-Else type of formula always provide the expected output
          for all the conditions.{" "}
          <span className="text-green-700 font-semibold">
            For Example : If A1 is greater than 100, add 10 else subtract 10
          </span>
        </p>

        <p className="mb-4">
          Use Column letters (Column A or Column B) instead of custom header
          names.{" "}
          <span className="text-green-700 font-semibold">
            For Example: Calculate the average of cells in column F.
          </span>
        </p>
      </div>

      <div className="pl-8 mb-8">
        <InstallAddonCta />
      </div>

      <div className="max-w-[95%] mx-auto p-4 border-2 bg-white rounded-xl">
        <h2 className="mb-4 text-xl tracking-tight font-bold">
          Contact Support
        </h2>
        <ContactForm title="" subtitle="" />
      </div>

      <div className="min-h-[5rem] md:hidden"></div>
    </div>
  );
};

export default HelpTab;
